import { useCallback, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDealershipTeam } from "../../context/DealershipTeamContext";

export const useDealershipTeamSnapshot = () => {
  const { contactId } = useParams();
  const {
    teamMembers,
    partyUuid,
    loading,
    error,
    isEmpty,
    fetchTeamMembers,
    resetTeamMembers,
  } = useDealershipTeam();

  const hasAttemptedLoadRef = useRef(false);


  useEffect(() => {
    if (contactId && partyUuid && partyUuid !== contactId) {
      resetTeamMembers();
      hasAttemptedLoadRef.current = false;
    }
  }, [contactId, partyUuid, resetTeamMembers]);

  
  useEffect(() => {
    if (!contactId) return;

    if (teamMembers.length && partyUuid === contactId) {
      hasAttemptedLoadRef.current = true;
      return;
    }

    if (hasAttemptedLoadRef.current) {
      return;
    }

    hasAttemptedLoadRef.current = true;
    fetchTeamMembers(contactId);
  }, [contactId, teamMembers.length, partyUuid, fetchTeamMembers]);

  const refetch = useCallback(() => {
    if (!contactId) return;
    hasAttemptedLoadRef.current = true;
    fetchTeamMembers(contactId);
  }, [contactId, fetchTeamMembers]);

  return {
    loading,
    error,
    isEmpty,
    teamMembers,
    refetch,
  };
};

